import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5537">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5538">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5539">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5540">
            <ArrowLeft className="w-4 h-4" data-id="element-5541" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5542">NOIZA</div>
          <div className="w-20" data-id="element-5543" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5544">
        <div className="mb-12" data-id="element-5545">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5546">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5547" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5548">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5549">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5550">
          <section data-id="element-5551">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5552">
              <span className="text-[#006847]" data-id="element-5553">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5554">
              <p data-id="element-5555">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5556">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5557">
                <li data-id="element-5558">Haber leído íntegramente este documento</li>
                <li data-id="element-5559">Comprender su contenido en su totalidad</li>
                <li data-id="element-5560">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5561">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5562">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5563">
              <span className="text-[#006847]" data-id="element-5564">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5565">
              <p data-id="element-5566">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5567">
                <li data-id="element-5568">Software como servicio (SaaS)</li>
                <li data-id="element-5569">Marketplace digital gastronómico</li>
                <li data-id="element-5570">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5571">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5572">
                <li data-id="element-5573">Mostrar su menú digital</li>
                <li data-id="element-5574">Recibir pedidos de clientes</li>
                <li data-id="element-5575">Gestionar su operación interna</li>
                <li data-id="element-5576">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5577">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5578">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5579">
              <span className="text-[#006847]" data-id="element-5580">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5581">
              <p data-id="element-5582">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5583">
                <li data-id="element-5584">No es proveedor de alimentos</li>
                <li data-id="element-5585">No participa en la preparación de productos</li>
                <li data-id="element-5586">No manipula alimentos en ningún momento</li>
                <li data-id="element-5587">No realiza entregas ni logística</li>
                <li data-id="element-5588">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5589">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5590">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5591">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5592">
              <span className="text-[#006847]" data-id="element-5593">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5594">
              <p data-id="element-5595">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5596">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5597">
                <li data-id="element-5598">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5599">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5600">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5601">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5602">
                <li data-id="element-5603">Precios</li>
                <li data-id="element-5604">Menú</li>
                <li data-id="element-5605">Horarios</li>
                <li data-id="element-5606">Métodos de pago</li>
                <li data-id="element-5607">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5608">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5609">
              <span className="text-[#006847]" data-id="element-5610">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5611">
              <div data-id="element-5612">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5613">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5614">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5615">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5616">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5617">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5618">
                  <li data-id="element-5619">Calidad de los alimentos</li>
                  <li data-id="element-5620">Estado, frescura o preparación</li>
                  <li data-id="element-5621">Ingredientes utilizados</li>
                  <li data-id="element-5622">Contaminación cruzada</li>
                  <li data-id="element-5623">Problemas de higiene o salubridad</li>
                  <li data-id="element-5624">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5625">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5626">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5627">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5628">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5629">
                  <li data-id="element-5630">Retrasos en la entrega</li>
                  <li data-id="element-5631">Pérdida de pedidos</li>
                  <li data-id="element-5632">Entregas incompletas</li>
                  <li data-id="element-5633">Errores en dirección</li>
                  <li data-id="element-5634">Conducta de repartidores</li>
                  <li data-id="element-5635">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5636">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5637">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5638">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5639">
                  <li data-id="element-5640">Recepción de pagos</li>
                  <li data-id="element-5641">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5642">Manejo de efectivo</li>
                  <li data-id="element-5643">Confirmación de pagos</li>
                  <li data-id="element-5644">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5645">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5646">
                  <li data-id="element-5647">Pagos no recibidos</li>
                  <li data-id="element-5648">Comprobantes falsos</li>
                  <li data-id="element-5649">Errores en montos</li>
                  <li data-id="element-5650">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5651">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5652">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5653">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5654">
                  <li data-id="element-5655">Reclamos de clientes</li>
                  <li data-id="element-5656">Reembolsos</li>
                  <li data-id="element-5657">Cancelaciones</li>
                  <li data-id="element-5658">Disputas</li>
                  <li data-id="element-5659">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5660">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5661">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5662">
              <span className="text-[#006847]" data-id="element-5663">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5664">
              <p data-id="element-5665">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5666">
                <li data-id="element-5667">Responsable</li>
                <li data-id="element-5668">Legal</li>
                <li data-id="element-5669">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5670">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5671">
                <li data-id="element-5672">Publicar información falsa</li>
                <li data-id="element-5673">Manipular precios de forma engañosa</li>
                <li data-id="element-5674">Simular disponibilidad inexistente</li>
                <li data-id="element-5675">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5676">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5677">
              <span className="text-[#006847]" data-id="element-5678">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5679">
              <p data-id="element-5680">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5681">
                <li data-id="element-5682">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5683">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5684">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5685">
                <li data-id="element-5686">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5687">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5688">
                    <li data-id="element-5689">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5690">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5691">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5692">
              <span className="text-[#006847]" data-id="element-5693">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5694">
              <p data-id="element-5695">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5696">
                <li data-id="element-5697">Menú digital</li>
                <li data-id="element-5698">Gestión de pedidos</li>
                <li data-id="element-5699">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5700">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5701">
                  <p className="font-medium text-white mb-2" data-id="element-5702">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5703">
                    <li data-id="element-5704">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5705">
                  <p className="font-medium text-white mb-2" data-id="element-5706">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5707">
                    <li data-id="element-5708">Propiedad del software</li>
                    <li data-id="element-5709">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5710">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5711">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5712">
              <span className="text-[#006847]" data-id="element-5713">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5714">
              <p data-id="element-5715">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5716">
                <li data-id="element-5717">Disponibilidad continua</li>
                <li data-id="element-5718">Funcionamiento sin interrupciones</li>
                <li data-id="element-5719">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5720">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5721">
                <li data-id="element-5722">Fallas técnicas</li>
                <li data-id="element-5723">Actualizaciones</li>
                <li data-id="element-5724">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5725">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5726">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5727">
              <span className="text-[#006847]" data-id="element-5728">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5729">
              <p data-id="element-5730">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5731">
                <li data-id="element-5732">No está garantizada permanentemente</li>
                <li data-id="element-5733">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5734">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5735">
                <li data-id="element-5736">Destacar o no restaurantes</li>
                <li data-id="element-5737">Modificar posiciones</li>
                <li data-id="element-5738">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5739">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5740">
              <span className="text-[#006847]" data-id="element-5741">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5742">
              <p data-id="element-5743">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5744">
                <li data-id="element-5745">Cumplir con los pagos acordados</li>
                <li data-id="element-5746">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5747">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5748">
                <li data-id="element-5749">Suspender el servicio</li>
                <li data-id="element-5750">Limitar funcionalidades</li>
                <li data-id="element-5751">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5752">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5753">
              <span className="text-[#006847]" data-id="element-5754">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5755">
              <p data-id="element-5756">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5757">
                <li data-id="element-5758">Incumplimiento de términos</li>
                <li data-id="element-5759">Uso indebido</li>
                <li data-id="element-5760">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5761">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5762">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5763">
              <span className="text-[#006847]" data-id="element-5764">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5765">
              <p data-id="element-5766">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5767">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5768">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5769">
              <span className="text-[#006847]" data-id="element-5770">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5771">
              <p data-id="element-5772">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5773">
                <li data-id="element-5774">Pérdidas económicas</li>
                <li data-id="element-5775">Daños indirectos</li>
                <li data-id="element-5776">Lucro cesante</li>
                <li data-id="element-5777">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5778">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5779">
              <span className="text-[#006847]" data-id="element-5780">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5781">
              <p data-id="element-5782">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5783">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5784">
              <span className="text-[#006847]" data-id="element-5785">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5786">
              <p className="font-medium" data-id="element-5787">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5788">
                <li data-id="element-5789">Ha leído este documento completo</li>
                <li data-id="element-5790">Comprende su alcance</li>
                <li data-id="element-5791">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}